import { Toast } from "native-base";

const InfoToast = (message) => {
	Toast.show({
		title: message,
		status: "info",
		placement: "top",
		duration: 5000,
	});
};

export default InfoToast;
